// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusLevelSection_wrapper__HTt+H"};